package er.prateek.crossly.config

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * The `settings` section of [AppConfig] -- which rows the Settings screen shows. Both default
 * to hidden: these are QA-only affordances ("Send Test Crash Report" throws a real uncaught
 * exception; "Reset Progress" wipes local progress), so real users never see them unless
 * Remote Config is deliberately flipped on for a QA cohort -- never the reverse of forgetting
 * to flip them off before a release.
 */
@Serializable
data class SettingsVisibilityConfig(
    @SerialName("show_reset_progress") val showResetProgress: Boolean = false,
    @SerialName("show_send_test_crash") val showSendTestCrash: Boolean = false,
    /**
     * "Show Coach Marks Again". Unlike the two above this is a player-facing convenience, not
     * a QA tool -- it only replays the first-run tips -- so it defaults to visible.
     */
    @SerialName("show_replay_coach_marks") val showReplayCoachMarks: Boolean = true,
) {
    companion object {
        val DEFAULT = SettingsVisibilityConfig()
    }
}
